const EventCard = require("../../entities/Cards/EventCard");
const Events = require("../../Constants/Events/Events");
const ByName = require("./ByName");

const classOf = ByName(Events);

const EventConverter = (eventName) =>
{
    const Class = classOf(eventName);
    return Class === undefined ? null : new EventCard(new Class());
}

module.exports = EventConverter;
